<template>
    <div class="product-characteristics">
        <v-container>
            <v-row
                class="my-0"
                v-for="attribute in productEnumAttributes"
                :key="attribute.id"
            >
                <v-col cols="12" class="px-0 py-0">
                    <v-autocomplete
                        v-model="enumAttributes[attribute.id]"
                        :items="attribute.values"
                        color="grey"
                        item-color="grey"
                        :label="attribute.name"
                        :multiple="attribute.multiple"
                        :search-input.sync="searchInput[attribute.id]"
                        return-object
                        item-text="name"
                        item-value="id"
                        small-chips
                        clearable
                        @change="attributeChange(attribute)"
                        :rules="rules"
                        required
                    >
                        <template v-slot:selection="data" v-if="attribute.multiple">
                            <v-chip
                                :input-value="data.item.name"
                                close
                                color="grey"
                                outlined
                                small
                                @click:close="remove(data.item, attribute.id)"
                            >
                                <div class="text-truncate" style="max-width: 90%">
                                    {{ data.item.name }}
                                </div>
                            </v-chip>
                        </template>
                    </v-autocomplete>
                </v-col>
                <v-col cols="12" class="py-0 px-0" v-if="numericEnum[attribute.id] && numericEnum[attribute.id].length">
                    <v-row>
                        <v-col cols="12" md="8" class="pt-0" v-for="(item, idx) in numericEnum[attribute.id]" :key="idx">
                            <v-card-title class="text-truncate caption text-left text-md-center py-2">
                                {{ item.valueName }} <span class="grey--text ml-5">{{ item.attributeName }}</span>
                            </v-card-title>
                            <v-row>
                                <v-col cols="9" class="py-1">
                                    <v-row v-if="isRange(attribute.id)">
                                        <v-col cols="6">
                                            <v-text-field
                                                class="my-0"
                                                color="grey"
                                                dense
                                                v-model="numericEnum[attribute.id][idx].minValue"
                                                :label="$t('fromOt')"
                                                @input="attributeChange(attribute)"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field
                                                class="my-0"
                                                color="grey"
                                                dense
                                                v-model="numericEnum[attribute.id][idx].maxValue"
                                                :label="$t('before')"
                                                @input="attributeChange(attribute)"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-text-field
                                        v-else
                                        class="my-0"
                                        color="grey"
                                        dense
                                        v-model="numericEnum[attribute.id][idx].value"
                                        @input="attributeChange(attribute)"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="3" class="py-1">
                                    <v-select
                                        class="my-0"
                                        color="grey"
                                        dense
                                        v-model="numericEnum[attribute.id][idx].unitID"
                                        :items="numericEnum[attribute.id][idx].units"
                                        :label="$t('unitOfMeasure')"
                                        item-text="name"
                                        item-value="id"
                                        @change="attributeChange(attribute)"
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col
                    cols="12" class="py-0 px-0"
                    v-if="enumAttributes[attribute.id] && enumAttributes[attribute.id].length"
                    v-for="subAttribute in attribute.sub"
                    :key="subAttribute.id"
                >
                    <v-row
                        class="my-0"
                        v-for="enumAttribute in enumAttributes[attribute.id]"
                        :key="enumAttribute.id"
                    >
                        <v-col cols="12" class="py-0">
                            <v-autocomplete
                                v-model="subEnumAttributes[subAttribute.id + '_' + enumAttribute.id]"
                                :items="subAttribute.values"
                                color="grey"
                                item-color="grey"
                                :label="`${subAttribute.name} (${enumAttribute.name})`"
                                :multiple="subAttribute.multiple"
                                :search-input.sync="searchInput[subAttribute.id + '_' + enumAttribute.id]"
                                return-object
                                item-text="name"
                                item-value="id"
                                small-chips
                                clearable
                                :rules="rules"
                                required
                                @change="subAttributeChange(subAttribute, enumAttribute.id)"
                            >
                                <template v-slot:selection="data" v-if="subAttribute.multiple">
                                    <v-chip
                                        :input-value="data.item.name"
                                        close
                                        color="grey"
                                        outlined
                                        small
                                        @click:close="remove(data.item, subAttribute.id + '_' + enumAttribute.id, true)"
                                    >
                                        <div class="text-truncate" style="max-width: 90%">
                                            {{ data.item.name }}
                                        </div>
                                    </v-chip>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import { MixinNumericEnumRelation } from "../../mixins"

    export default {
        name: "ProductAttributes",
        props: ['initialAttributes', 'productAttributes'],
        mixins: [ MixinNumericEnumRelation],
        data() {
            return {
                manufacturerAttributeName: "proizvoditel",
                actionSubstancesRatio: {},
                enumAttributes: {},
                subEnumAttributes: {},
                numericAttributes: [],
                // rules: [value => !!value || this.$t('requiredField')],
                rules: [],
                valueModel: null,
                valueModels: [],
                searchInput: {}
            }
        },
        computed: {
            productEnumAttributes() {
                return this.productAttributes.enum?.filter(attribute => !attribute.is_sub) || [];
            },
            searchData: {
                get() {
                    return this.attribute.multiple ? this.valueModels : this.valueModel;
                },

                set(value) {
                    if(this.attribute.multiple) {
                        this.valueModels = value;
                    } else {
                        this.valueModel = value;
                    }
                },
            },
            normalizedSubEnumAttributes() {
                return Object.entries(this.subEnumAttributes)
                    .flatMap(([key, value]) => {
                        const parent_id = +key.split('_').pop();

                        return value.map(attr => ({
                            ...attr,
                            parent_id,
                        }));
                    })
            },
        },
        methods: {
            attributeChange(attribute) {
                this.checkRelation(attribute.id);
                this.emitChange();
                this.searchInput[attribute.id] = '';
            },
            subAttributeChange(subAttribute, enumAttributeId) {
                this.emitChange();
                this.searchInput[subAttribute.id + '_' + enumAttributeId] = '';
            },
            emitChange() {
                const attributes = {
                    enumAttributes: this.enumAttributes,
                    subEnumAttributes: this.normalizedSubEnumAttributes,
                    numericAttributes: this.numericAttributes,
                    numericEnum: this.numericEnum
                };
                this.$emit('attribute-change', attributes);
            },
            remove(item, attributeID, fromSub = false) {
                const targetKey = fromSub ? 'subEnumAttributes' : 'enumAttributes';
                const attribute = this[targetKey][attributeID];

                if (Array.isArray(attribute)) {
                    this[targetKey][attributeID] = this[targetKey][attributeID].filter(attr => attr.id !== item.id);

                    if (!this[targetKey][attributeID].length) {
                        delete this[targetKey][attributeID];
                    }
                } else {
                    delete(this.enumAttributes[attributeID]);
                }

                if (!fromSub) {
                    const id = item.id.toString();
                    this.subEnumAttributes = Object.fromEntries(
                        Object.keys(this.subEnumAttributes)
                            .filter(key => !key.endsWith(id))
                            .map(key => [key, this.subEnumAttributes[key]])
                    )
                }

                this.checkRelation(attributeID);
                this.emitChange();
            },
            setInitial() {
                if (!this.initialAttributes) return false;

                this.setInitialEnum();
                this.setInitialSubEnum();
                this.setInitialNumericEnum();

                this.emitChange();
            },
            setInitialEnum() {
                if (!this.initialAttributes.enumAttributes)
                    return false;

                this.enumAttributes = this.initialAttributes.enumAttributes.reduce(this.setEnumCallback, {});
                this.$emit('attribute-change', this.enumAttributes);
            },
            setInitialSubEnum() {
                if (!this.initialAttributes.subEnumAttributes) {
                    return false;
                }

                this.subEnumAttributes = this.initialAttributes.subEnumAttributes.reduce(this.setEnumCallback, {})
            },
            setInitialNumericEnum() {
                if (!this.initialAttributes.numericAttributes)
                    return false;

                const attributes = {};

                this.initialAttributes.numericAttributes.forEach(item => {
                    if(!item.enumID) return false;

                    if(!attributes[item.enumID])
                        attributes[item.enumID] = [];

                    attributes[item.enumID].push(item)
                });

                this.numericEnum = attributes;
            },
            setEnumCallback(result, current) {
                if (current.attributeSystemName === this.manufacturerAttributeName) {
                    return result;
                }

                const key = current.parentID ? current.attributeID + '_' + current.parentID : current.attributeID;
                const data = {
                    id: current.valueID,
                    name: current.valueName,
                    system_name: current.valueSystemName,
                };

                if(current.multiple) {
                    if(!result[key]) {
                        result[key] = [];
                    }

                    result[key].push(data);
                } else {
                    result[key] = data;
                }

                return result;
            },
            isRange(attributeID) {
                const numericAttrs = this.productAttributes.numeric;
                const attribute = numericAttrs ? numericAttrs.find(attr => attr.enumID === attributeID) : null;

                if (!attribute) {
                    return false;
                }

                return attribute.isRange;
            },
        },
        watch: {
            initialAttributes() {
                this.setInitial();
            },
            productAttributes() {
                this.enumAttributes = {};
                this.setInitial();
            }
        }
    }
</script>

<style scoped>

</style>
